module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Edit division","eventsDivisionsActionsEditOneSuccess":"%{divisionDay} kl. %{divisionStartsAt} was successfully updated in the database"},"no":{"dialogTitle":"Rediger standplassliste","eventsDivisionsActionsEditOneSuccess":"%{divisionDay} kl. %{divisionStartsAt} ble redigert i databasen"}}')
  delete Component.options._Ctor
}
